<template>
    <div class="documents">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="modal_ingreso" title="Agregar información bancaria">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <div>
                    <label for="">Fecha desde que elabora</label>
                    <input type="date" v-model="date">
                </div>
                <div>
                    <label for="">Monto</label>
                    <input type="number" v-model="cant">
                </div>
                <button @click="GenerateDocument(item)">Generar</button>
            </div>
        </b-modal>
        <div>
            <div class="pending">
                <center>
                    <h3>Solicitudes pendientes</h3>
                    <div>
                        <label><div>Fecha</div></label>
                        <label><div>Solicitud</div></label>
                        <label><div>Modelo</div></label>
                        <label><div>Documento</div></label>
                        <label><div>Aprobar</div></label>
                    </div>
                    <div v-for="(item, index) in pending" :key="index">
                        <label><div>{{item.created_at.split($store.state.constants.SEPARETOR)[0]}}</div></label>
                        <label><div>{{item.id}}</div></label>
                        <label><div>{{item.model}}</div></label>
                        <label><div>{{item.type}}</div></label>
                        <label>
                            <div v-if="item.type === 'bancario'"><button  @click="GenerateDocument(item.id)">Generar</button></div>
                            <div v-else><button @click="openIngresoModal(item.id)">Generar</button></div>
                        </label>
                    </div>
                </center>
            </div>
        </div>
        <div>
            <div class="approved">
                <center>
                    <h3>Solicitudes Aprobadas</h3>
                    <div>
                        <label><div>Fecha</div></label>
                        <label><div>Solicitud</div></label>
                        <label><div>Modelo</div></label>
                        <label><div>Documento</div></label>
                        <label><div>Documento</div></label>
                    </div>
                    <div v-for="(item, index) in approved" :key="index">
                        <label><div>{{item.created_at.split($store.state.constants.SEPARETOR)[0]}}</div></label>
                        <label><div>{{item.id}}</div></label>
                        <label><div>{{item.model}}</div></label>
                        <label><div>{{item.type}}</div></label>
                        <label><div><button><a :href="item.document" target="_blank">VER</a></button></div></label>
                    </div>
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Notify from '@/utils/Notification.js'

export default {
    name: 'documents',
    data() {
        return {
            approved: [],
            pending: [],
            item: null,
            cant: null,
            date: null
        }
    },
    beforeMount() {
        this.$root.$emit('solicitud', this.$route.name)
    },
    methods: {
        openIngresoModal(id) {
            this.$refs.modal_ingreso.show()
            this.item = id
        },
        GenerateDocument(id) {
            if (id === 'ingresos' && (this.cant === null || this.date === null)) {
                return
            }
            var info = {
                cant: this.cant,
                date: this.date
            }
            API.generateDocument(id, info)
                .then((res) => {
                    this.getPendingDocuments()
                    this.getApprovedDocuments()
                    this.$refs.modal_ingreso.hide()
                    Notify('dirty', 'La solicitud de documento se ha actualizado con exito')
                })
        },
        getPendingDocuments() {
            API.getPendingDocuments()
                .then((res) => {
                    this.pending = res
                })
        },
        getApprovedDocuments() {
            API.getApprovedDocuments()
                .then((res) => {
                    this.approved = res
                })
        }
    },
    mounted() {
        this.getPendingDocuments()
        this.getApprovedDocuments()
    }
}
</script>

<style scoped>
    .documents {
        display: flex;
        background-color: #cdcdcd;
    }
    .documents > div {
        width: 50%;
        height: 78vh;
        padding: 20px;
    }
    .documents > div > .pending {
        background-color: #8363b7;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
    }
    .documents > div > .approved {
        background-color: #585858;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
    }
    .documents > div > div > center {
        overflow-y: auto;
        height: 100%;
    }
    .documents > div > div > center > h3 {
        color: #fff;
        font-weight: bold;
        padding-bottom: 30px;
        padding-top: 30px;
    }
    .documents > div > div > center > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 60px;
        position: relative;
    }
    .documents > div > div > center > div > label{
        width: 19%;
        position: relative;
        height: 100%;
    }
    .documents > div > div > center > div > label > div{
        width: 100%;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%,-50%);
    }
    .documents > div > div > center > div > label > div > button{
        background-color: #e0b059;
        color: #fff;
        border-radius: 30px;
        font-weight: bold;
    }
    .info-wrapper > div {
        display: grid;
        padding: 20px;
    }
    .info-wrapper > div > label {
        font-weight: bold;
    }
    .info-wrapper > div > input {
        width: 250px;
        height: 40px;
        text-align: center;
        border-radius: 15px;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Solicitudes/Documentos.vue